import React from "react";
import CheckboxControl from "../../../components/Fields/CheckboxControl";
import Field from "../../../components/Fields/Field";
import SelectListControl from "../../../components/Fields/SelectListControl";
import SwitchControl from "../../../components/Fields/SwitchControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { ControlProps, FieldProps, LabelProps } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import SettingModel from "../../../models/settings/SettingModel";

export interface Props {
    getLabelProps: (string) => LabelProps
    getControlProps: (string) => ControlProps
    fieldName: string
    index: number
    settings: SettingModel
}

const Setting: React.FC<Props> = ({ settings, getLabelProps, getControlProps, fieldName, index }) => {
    const settingLevels = useSelectListOptions('api/v1/selectlist/SettingLevels', '-- Select level');
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypesGeneratable', '-- Select attachment type');

    return (
        <Field {...getLabelProps(`${fieldName}.${index}.value`)}>
            {settings.dataTypeId != 10 && settings.dataTypeId != 7  && <TextboxControl {...getControlProps(`${fieldName}.${index}.value`)} />}
            {settings.dataTypeId == 10 && <SelectListControl {...getControlProps(`${fieldName}.${index}.value`)} options={attachmentTypes} />}
            {settings.dataTypeId == 7 && <SwitchControl {...getControlProps(`${fieldName}.${index}.value`)} onValue='True' offValue='False' />}

            <span style={{ marginLeft: 5, width: 180 }}>
                <SelectListControl {...getControlProps(`${fieldName}.${index}.level`)} options={settingLevels} />
            </span>
        </Field>
    );
}
export default Setting;